"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var appBuilder;
        (function (appBuilder) {
            var index;
            (function (index_1) {
                class InitArgs {
                    constructor() {
                        this.canSave = false;
                        this.shortDateFormatDefault = appn.emptyString;
                        this.shortTimeFormatDefault = appn.emptyString;
                        this.languages = new Array();
                    }
                }
                let _initArgs;
                const _DataSources = [];
                const _StaticOptions = [];
                const tooltipTemplate = '<span class="toolTip" data-widget="popover" data-trigger="manual" data-html="true" data-content="%hint%" data-container="body" data-placement="top"><i class="fa fa-question-circle"></i></span>';
                function init(args) {
                    _initArgs = args;
                    appn.services.validateDateFormat(String($('#AppConfig_DateFormat').val()), $('#dateFormatResult'));
                    appn.services.validateDateFormat(String($('#AppConfig_TimeFormat').val()), $('#timeFormatResult'));
                    appn.minicolors.init(function () {
                        if ($('#colorPreview').length) {
                            const picker = String(this.id);
                            (picker.containsIgnoreCase('Background')) ? appn.minicolors.refreshPreviewBody() : appn.minicolors.refreshPreviewTitle();
                        }
                    }, args.canSave, $('.colorPickerLeftBottom'), 'bottom left');
                    appn.minicolors.init(function () { }, args.canSave, $('.infoAlertFormulaColor'), 'bottom left');
                    appn.minicolors.init(function () {
                        if ($('#colorPreview').length) {
                            const picker = String(this.id);
                            (picker.containsIgnoreCase('Background')) ? appn.minicolors.refreshPreviewBody() : appn.minicolors.refreshPreviewTitle();
                        }
                    }, args.canSave, $('.colorPickerRightBottom'), 'bottom right');
                    appn.minicolors.init(function () {
                        if ($('#colorPreview').length) {
                            const picker = String(this.id);
                            (picker.containsIgnoreCase('Background')) ? appn.minicolors.refreshPreviewBody() : appn.minicolors.refreshPreviewTitle();
                        }
                    }, args.canSave, $('.colorPickerLeftTop'), 'top left');
                    appn.minicolors.init(function () {
                        if ($('#colorPreview').length) {
                            const picker = String(this.id);
                            (picker.containsIgnoreCase('Background')) ? appn.minicolors.refreshPreviewBody() : appn.minicolors.refreshPreviewTitle();
                        }
                    }, args.canSave, $('.colorPickerRightTop'), 'top right');
                    $('.bgColourTransparent').each(function () {
                        setBackgroundColor($(this));
                        $(this).trigger('change');
                    });
                    $('.choices .isDataSource').each(function (index, isDataSource) {
                        const radiosList = $('.choices .editorRadios input[type = "radio"]');
                        const dataSourceList = $('.choices .dataSource');
                        const staticOptionsList = $('.choices .staticList');
                        if (JSON.parse(String($(isDataSource).val()).toLowerCase())) {
                            $(`.choices#${index}`).find('.dsSelector').removeClass('d-none');
                            _DataSources.push(String($(dataSourceList[index]).val()));
                            $(`.choices#${index}`).find(`.dsSelector select option`).each(function (i, option) {
                                if ($(option).text() === _DataSources[index])
                                    $(`.choices#${index}`).find('.dsSelector select').val(String($(option).val()));
                            });
                            radiosList[(index * 2) + 1].checked = true;
                            if (Number($(staticOptionsList[index]).closest('.choices').attr('id')) === index)
                                $(`.choices#${index} .staticList`).val('');
                            _StaticOptions.push(appn.emptyString);
                        }
                        else {
                            $(`.choices#${index}`).find('.optionsEditor').removeClass('d-none');
                            let newOptionsListString = '';
                            let newOptionsList = [];
                            if (String($(staticOptionsList[index]).val()).contains(','))
                                String($(staticOptionsList[index]).val()).split(',').forEach(function (option, i) {
                                    newOptionsList.push(option);
                                });
                            else if (String($(staticOptionsList[index]).val()).contains('|'))
                                newOptionsList.push(String($(staticOptionsList[index]).val()));
                            newOptionsList = newOptionsList.filter(e => e !== '|');
                            if (newOptionsList.length === 0)
                                newOptionsList.push('|');
                            newOptionsListString = newOptionsList.join(',');
                            _StaticOptions.push(newOptionsListString);
                            handleStaticOptions('populate', undefined, undefined, 0, $(`.choices#${index}`).find('.optionsEditor'));
                            radiosList[(index * 2)].checked = true;
                            if (Number($(dataSourceList[index]).closest('.choices').attr('id')) === index)
                                $(`.choices#${index} .dataSource`).val('');
                            _DataSources.push(appn.emptyString);
                        }
                    });
                    $('.action .button').each((index, button) => {
                        const dataName = $(button).data('name');
                        const styleElement = $(button).find('.fontStyle');
                        const control = $(`.control.action`);
                        const checkbox = $(button).find('.colorSelector input[type="checkbox"]');
                        setActionButtonStyle(control, dataName, styleElement);
                        setActionButtonBackground(control, dataName, checkbox);
                    });
                    $('.fieldTheme.field .colorSelector[data-name^="btnColor"]').each((index, colorSelector) => {
                        const $colorSelector = $(colorSelector);
                        const settingName = $colorSelector.data('name');
                        const control = $(`.control.inputMedia`);
                        const checkbox = $colorSelector.find('input[type="checkbox"]');
                        let dataName = '';
                        if (settingName === 'btnColor0')
                            dataName = 'media-btn0';
                        else if (settingName === 'btnColor1')
                            dataName = 'media-btn1';
                        else if (settingName === 'btnColor2')
                            dataName = 'media-btn2';
                        if (dataName && control.length && checkbox.length) {
                            setActionButtonBackground(control, dataName, checkbox);
                        }
                    });
                    $('.fieldTheme.field .tab-pane[data-name^="btn"]').each(function () {
                        const $tabPane = $(this);
                        const $textColorPicker = $tabPane.find('.backgroundStyle .colorPicker');
                        if (!$textColorPicker.length)
                            return;
                        const control = $(`.control.inputMedia`);
                        let dataName = appn.emptyString;
                        const tabName = $tabPane.data('name');
                        if (tabName === 'btn0')
                            dataName = 'media-btn0';
                        else if (tabName === 'btn1')
                            dataName = 'media-btn1';
                        else if (tabName === 'btn2')
                            dataName = 'media-btn2';
                        if (dataName && control.length) {
                            setMediaButtonTextColor(control, dataName, $textColorPicker);
                        }
                    });
                    if (!$('#AppConfig_InfoAlertConfig_TitleStyle_Color').val().startsWith('#'))
                        showFormulaButtons($('#AppConfig_InfoAlertConfig_TitleStyle_Color'));
                    if (!$('#AppConfig_InfoAlertConfig_SubtitleStyle_Color').val().startsWith('#'))
                        showFormulaButtons($('#AppConfig_InfoAlertConfig_SubtitleStyle_Color'));
                    if (!$('#AppConfig_InfoAlertConfig_BackgroundColor').val().startsWith('#'))
                        showFormulaButtons($('#AppConfig_InfoAlertConfig_BackgroundColor'));
                    updateInfoAlertText();
                    updateTextStyle($('.controlLabelInfoAlertTitle'), $('.infoAlertTitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
                    updateTextStyle($('.controlLabelInfoAlertSubtitle'), $('.infoAlertSubtitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
                    updateInfoAlertColors($('#titleColor'));
                    updateInfoAlertColors($('#subtitleColor'));
                    updateInfoAlertColors($('#bgColor'));
                    addEvents();
                    showSelectedTheme();
                    toggleOptionalSelects();
                    appn.select.init({ selector: 'select.themeSelector,.propertiesPane.rightPropertiesPane select:not(.iconSelect)', omitWidth: true });
                    appn.select.init({ selector: '.interactionType,.interactScreen,.interactDoc', omitWidth: false });
                    appn.select.init({
                        selector: '#iconsToDisplay',
                        isIconSelect: true
                    });
                    appn.select.init({
                        selector: '.fieldTypeIconPicker',
                        isIconSelect: true
                    });
                }
                index_1.init = init;
                function addEvents() {
                    $('#AppConfig_DateFormat').change(function () {
                        if (!(String($('#AppConfig_DateFormat').val()).length > 0))
                            $('#AppConfig_DateFormat').val(_initArgs.shortDateFormatDefault);
                        appn.services.validateDateFormat(String($('#AppConfig_DateFormat').val()), $('#dateFormatResult'));
                    });
                    $('#AppConfig_TimeFormat').change(function () {
                        if (!(String($('#AppConfig_TimeFormat').val()).length > 0))
                            $('#AppConfig_TimeFormat').val(_initArgs.shortTimeFormatDefault);
                        appn.services.validateDateFormat(String($('#AppConfig_TimeFormat').val()), $('#timeFormatResult'));
                    });
                    $('#AppConfig_StartScreen').change(function () {
                        if ($(this).val() === '00000000-0000-0000-0000-000000000000')
                            $('.customiseStart').show();
                        else
                            $('.customiseStart').hide();
                    });
                    $('.function-icon').on('click', function () {
                        showFormulaButtons($(this));
                        const parentDiv = $(this).closest('div.propContent');
                        parentDiv.find('.colorVal').val(parentDiv.find('.formula input').val());
                    });
                    $('.color-function-icon').on('click', function () {
                        hideFormulaButtons($(this));
                        const parentDiv = $(this).closest('div.propContent');
                        parentDiv.find('.colorVal').val(parentDiv.find('.color-picker input').val());
                    });
                    $('.toggleDesignerLanguages').click((event) => {
                        event.preventDefault();
                        $('#designerLanguagesModal').modal('show');
                    });
                    $(document).on('click', '.buildIcon,.formula-icon', function (e) {
                        e.preventDefault();
                        const formulaBox = $(this).closest('div.input-group-sm').find('input');
                        appn.ui.formulabuilder.currentFormula = formulaBox.val();
                        appn.ui.formulabuilder.currentMode = $(this).data('type');
                        appn.ui.formulabuilder.formulaUpdated = function (formula) {
                            formulaBox.val(formula);
                            formulaBox.trigger('change');
                            formulaBox.trigger('keyup');
                        };
                        appn.ui.formulabuilder.showDialog();
                    });
                    $('.btn-applyLanguageChange').on('click', (event) => {
                        event.preventDefault();
                        $('#designerLanguagesModal').modal('hide');
                        const selectedLanguage = $('#SelectedInfoAlertLanguage').val();
                        _initArgs.languages.forEach((language, i, a) => {
                            const titleInput = $(`input[name="AppConfig.InfoAlertConfig.Title[${language}]"`).closest('.titleInput');
                            const subtitleInput = $(`input[name="AppConfig.InfoAlertConfig.Subtitle[${language}]"`).closest('.subtitleInput');
                            titleInput.toggleClass("d-none", language !== selectedLanguage);
                            subtitleInput.toggleClass("d-none", language !== selectedLanguage);
                        });
                        $('#displaySelectedLanguage').text(selectedLanguage == 'eng' ? 'english' : selectedLanguage);
                        updateInfoAlertText();
                    });
                    $(document).on('keyup', '.titleInput input,.subtitleInput input', function () {
                        updateInfoAlertText();
                    });
                    $('#iconsToDisplay').change(function () {
                        $('#infoAlertConfigIcon').attr('src', $('#iconsToDisplay').find(':selected').data('imagesrc'));
                    });
                    $('#AppConfig_TitleTextColor').change(function () {
                        $('.titleBar .controlLabel').css('color', $('#AppConfig_TitleTextColor').val());
                    });
                    $(document).on('change', '.interactionSelect,.interactValue,.interactScreen,.interactDoc', function (e) {
                        e.preventDefault();
                        toggleOptionalSelects();
                    });
                    $(document).on('change', '#titleColor,#titleColorFormula,#subtitleColor,#subtitleColorFormula,#bgColor,#bgColorFormula', function () {
                        $(this).closest('div.propContent').find('.colorVal').val($(this).val());
                        updateInfoAlertColors($(this));
                    });
                    $('#AppConfig_NavStyle_Color').change(function () {
                        $('.titleBar .controlInfo  span').css('color', $('#AppConfig_NavStyle_Color').val());
                    });
                    $('#AppConfig_TitleTextColor').trigger('change');
                    $('#AppConfig_NavStyle_Color').trigger('change');
                    $('#AppConfig_StartScreen').trigger('change');
                    $('.fontStyle .displayButton').click(function () {
                        if ($(this).hasClass('active')) {
                            $(this).removeClass('active');
                            $(this).closest('.fontStyle').find('.decor').val('Normal');
                        }
                        else {
                            $(this).closest('.fontStyle').find('.active').removeClass('active');
                            $(this).addClass('active');
                            $(this).closest('.fontStyle').find('.decor').val($(this).data('type'));
                        }
                        updateThemeDisplay();
                        updateTextStyle($('.controlLabelInfoAlertTitle'), $('.infoAlertTitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
                        updateTextStyle($('.controlLabelInfoAlertSubtitle'), $('.infoAlertSubtitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
                    });
                    $('#AppConfig_InfoAlertConfig_TitleStyle_Size,#AppConfig_InfoAlertConfig_SubtitleStyle_Size').change(function () {
                        updateTextStyle($('.controlLabelInfoAlertTitle'), $('.infoAlertTitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
                        updateTextStyle($('.controlLabelInfoAlertSubtitle'), $('.infoAlertSubtitleStyle'), { Small: 1, Medium: 1.2, Large: 1.4 }, true);
                    });
                    $('.themeSelector').change(function () {
                        showSelectedTheme();
                        $('.rightPropsScroller').scrollTop($('.rightPropsScroller')[0].scrollHeight);
                    });
                    $('.btnDefaultTheme').click(function () {
                        customSubmit('DefaultTheme');
                    });
                    $('.btnAddTheme').click(function () {
                        customSubmit('AddTheme');
                    });
                    $('.btnDeleteTheme').click(function () {
                        appn.dialog.confirm({
                            modalColor: 'modal-danger',
                            title: T('Delete Theme'),
                            message: T('Are you sure you want to delete?'),
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('OK') + '</span>',
                                    className: 'btn-success'
                                }
                            },
                            callback: function (result) {
                                if (result)
                                    customSubmit('DeleteTheme');
                            }
                        });
                    });
                    $('.typeSelect .dropdown-menu a').on('click', function (e) {
                        setTypeSelect($(this).data('typevalue'), $(this).text());
                        showSelectedTheme();
                    });
                    $('.typeSelect').on('change', function (e) {
                        showSelectedTheme();
                    });
                    $('.designerTheme').find('input, select').change(function () {
                        updateThemeDisplay();
                    });
                    $('.control').click(function (e) {
                        if ($(this).hasClass('titleBar') || $(this).hasClass('infoAlertPreview'))
                            return;
                        e.stopPropagation();
                        const typeVal = $(this).data('type');
                        setTypeSelect(typeVal);
                        $('.typeSelect .dropdown-toggle').trigger('change');
                    });
                    $('.colorPicker').change(function () {
                        if ($(this).val())
                            $(this).closest('.backgroundStyle').find('.bgColourTransparent').prop('checked', false);
                    });
                    $('.titleBar, .workspaceContainer').click(function () {
                        $('.rightPropsScroller').scrollTop(0);
                    });
                    $('input[id$="IsDefault"]').on('click', function (e) {
                        const themeGuid = $(this).closest('.themeName').find('input.id').val();
                        $('input[id$="IsDefault"]').prop('checked', false);
                        $(this).prop('checked', true);
                        $('.themeSelector').find('option').each((i, o) => {
                            if ($(o).text().toLowerCase().indexOf('(default)'))
                                $(o).text($(o).text().replace(' (Default)', ''));
                        });
                        $('.themeSelector').find(`option[value="${themeGuid}"]`).text($('.themeSelector').find(`option[value="${themeGuid}"]`).text() + ' (Default)');
                    });
                    $('form').on('submit', function () {
                        const $mediaTransparentCheckboxes = $(this).find('input[id*="-primary-bgtransparent"], input[id*="-secondary-bgtransparent"], input[id*="-tertiary-bgtransparent"]');
                        $mediaTransparentCheckboxes.filter(':checked').each(function () {
                            const $checkbox = $(this);
                            const $parent = $checkbox.closest('.colorSelector');
                            const $colorPicker = $parent.find('.colorPicker');
                            if ($colorPicker.val() === '') {
                                $colorPicker.val('transparent');
                            }
                        });
                    });
                    addChoicesEvents();
                    addActionEvents();
                    addFieldIconEvents();
                }
                const toggleOptionalSelects = function () {
                    const screenContainer = $('.interactScreenContainer');
                    const docContainer = $('.interactDocContainer');
                    const valueContainer = $('.interactValueContainer');
                    const interactionType = $('.interactionSelect').val();
                    screenContainer.hideElement();
                    docContainer.hideElement();
                    valueContainer.showElement();
                    if (interactionType == 'OpenScreen') {
                        screenContainer.showElement();
                        $('#AppConfig_InfoAlertConfig_Interaction_InteractScreen').val($('.interactScreen').val());
                    }
                    else if (interactionType == 'OpenDoc') {
                        docContainer.showElement();
                        if ($('.interactDoc').val()) {
                            $('#AppConfig_InfoAlertConfig_Interaction_InteractValue').val(appn.emptyString);
                            valueContainer.hideElement();
                            $('#AppConfig_InfoAlertConfig_Interaction_InteractScreen').val($('.interactDoc').val());
                        }
                        else {
                            valueContainer.showElement();
                            $('#AppConfig_InfoAlertConfig_Interaction_InteractScreen').val(appn.emptyString);
                        }
                    }
                    else if (interactionType == 'None') {
                        valueContainer.hideElement();
                    }
                    const dynaTipTarget = $('.interactValueContainer .dynatip');
                    const toolTip = $(`.interactionTip${interactionType}`).text();
                    if (dynaTipTarget.length > 0)
                        if (dynaTipTarget.text().length === 0)
                            dynaTipTarget.remove();
                        else
                            dynaTipTarget.text(dynaTipTarget.text()).append(tooltipTemplate.replace('%hint%', toolTip));
                    const dynaTip = dynaTipTarget.find('span.toolTip');
                    dynaTip.attr('data-content', $('.interactionTip' + interactionType).html());
                    appn.popover.init();
                };
                function addChoicesEvents() {
                    $('.choices .editorRadios input[type="radio"]').on('click', function (event) {
                        const current = this;
                        const parent = $(this).parent();
                        const theme = $(this).closest('.choices');
                        const themeIndex = Number(theme.attr('id'));
                        const choices = parent.find('input[type="radio"]');
                        const staticList = $(theme).find('.optionsEditor');
                        const dataSource = $(theme).find('.dsSelector');
                        choices.each(function (index, choice) {
                            choice.checked = false;
                        });
                        current.checked = true;
                        staticList.addClass('d-none');
                        dataSource.addClass('d-none');
                        if (String(current.value).containsIgnoreCase('Static')) {
                            theme.find('.isDataSource').prop('value', false);
                            staticList.removeClass('d-none');
                            const staticListString = _StaticOptions[themeIndex];
                            let staticListStrings = [];
                            if (staticListString.contains(','))
                                staticListStrings = staticListString.split(',');
                            else if (staticListString.contains('|'))
                                staticListStrings.push(staticListString);
                            if (staticList.find('.optionsList > li').length === 0 && staticListStrings.length === 0)
                                addChoicesStaticRow(staticList, true);
                        }
                        else {
                            theme.find('.isDataSource').prop('value', true);
                            dataSource.removeClass('d-none');
                            theme.find('.dsSelect').val(_DataSources[themeIndex]);
                        }
                    });
                    $('.choices .optionsEditor .addOption').on('click', function (event) {
                        const parent = $(this).parent();
                        addChoicesStaticRow(parent, true);
                    });
                    $('.choices .dsSelector').on('change', function (event) {
                        const selected = String($(this).find('.dsSelect').val());
                        const dsName = String($(this).find(`option[value="${selected}"]`).text());
                        $(this).closest('.choices').find('.dataSource').val(dsName);
                    });
                    appn.minicolors.toggleColorPickerMulti();
                }
                function addActionEvents() {
                    $('.action .nav-link').on('click', function () {
                        const tabId = parseInt($(this).text().trim()) - 1;
                        const tabContents = $('.action .tab-content');
                        tabContents.find('.active.show').removeClass('active show');
                        tabContents.find(`#tab-${tabId}`).addClass('active show');
                        $('.action .nav-link').removeClass('active');
                        $(`.action #tab-${tabId}-tab`).addClass('active');
                    });
                    $('.action .button[data-name^="btn"]').find('.displayButton').on('click', function () {
                        var _a;
                        const dataName = $(this).closest('.button').data('name');
                        const styleElement = $(this).closest('.fontStyle');
                        const controlClass = (_a = $(this).closest('.fieldTheme').attr('class')) === null || _a === void 0 ? void 0 : _a.split(' ')[1];
                        const control = $(`.control.${controlClass}`);
                        setActionButtonStyle(control, dataName, styleElement);
                    });
                    $('.action .button[data-name^="btn"]').find('.colorPicker[id*="BtnStyle"],select[id*="BtnStyle"]').on('change', function () {
                        const dataName = $(this).closest('.button').data('name');
                        const styleElement = $(this).closest('.fontStyle');
                        const control = $(`.control.action`);
                        setActionButtonStyle(control, dataName, styleElement);
                    });
                    $('.action .button[data-name^="btn"]').find('.colorPicker,input[type="checkbox"]').on('change', function () {
                        var _a;
                        const dataName = $(this).closest('.button').data('name');
                        const controlClass = (_a = $(this).closest('.fieldTheme').attr('class')) === null || _a === void 0 ? void 0 : _a.split(' ')[1];
                        const control = $(`.control.${controlClass}`);
                        const checkbox = $(this).attr('type') === 'checkbox' ? $(this) : $(this).closest('.colorSelector').find('input[type="checkbox"]');
                        setActionButtonBackground(control, dataName, checkbox);
                    });
                    $('.fieldTheme.field .colorSelector .colorPicker, .fieldTheme.field .colorSelector input[type="checkbox"]').on('change', function () {
                        const fieldTheme = $(this).closest('.fieldTheme.field');
                        const designerTheme = fieldTheme.closest('.designerTheme');
                        if (designerTheme.find('.id').val() !== $('.themeSelector').val())
                            return;
                        const buttonWrapper = $(this).closest('[data-name^="btnColor"]');
                        let dataName = appn.emptyString;
                        if (buttonWrapper.data('name') === 'btnColor0')
                            dataName = 'media-btn0';
                        else if (buttonWrapper.data('name') === 'btnColor1')
                            dataName = 'media-btn1';
                        else if (buttonWrapper.data('name') === 'btnColor2')
                            dataName = 'media-btn2';
                        if (dataName !== appn.emptyString) {
                            const control = $('.control.inputMedia');
                            const checkbox = $(this).attr('type') === 'checkbox' ? $(this) : buttonWrapper.find('input[type="checkbox"]');
                            setActionButtonBackground(control, dataName, checkbox);
                        }
                    });
                    $('.fieldTheme.field .tab-pane .backgroundStyle .colorPicker').on('change', function () {
                        const fieldTheme = $(this).closest('.fieldTheme.field');
                        const designerTheme = fieldTheme.closest('.designerTheme');
                        if (designerTheme.find('.id').val() !== $('.themeSelector').val())
                            return;
                        const tabPane = $(this).closest('.tab-pane');
                        let dataName = appn.emptyString;
                        const tabName = tabPane.data('name');
                        if (tabName === 'btn0')
                            dataName = 'media-btn0';
                        else if (tabName === 'btn1')
                            dataName = 'media-btn1';
                        else if (tabName === 'btn2')
                            dataName = 'media-btn2';
                        if (dataName !== appn.emptyString) {
                            const control = $('.control.inputMedia');
                            setMediaButtonTextColor(control, dataName, $(this));
                        }
                    });
                }
                function addFieldIconEvents() {
                    $('.fieldTypeIconManager').each(function () {
                        let $manager = $(this);
                        let $fieldTypeSelector = $manager.find('.fieldTypeSelector');
                        let $iconPicker = $manager.find('.fieldTypeIconPicker');
                        let $hiddenFields = $manager.find('.fieldTypeIconMappingsContainer');
                        $fieldTypeSelector.on('change', function () {
                            let selectedFieldType = $(this).val();
                            if (selectedFieldType) {
                                let iconValue = $hiddenFields.find('input[data-field-type="' + selectedFieldType + '"]').val();
                                $iconPicker.val(iconValue).trigger('change.select2');
                            }
                        });
                        $iconPicker.on('change', function () {
                            let selectedFieldType = $fieldTypeSelector.val();
                            if (selectedFieldType) {
                                $hiddenFields.find('input[data-field-type="' + selectedFieldType + '"]').val($(this).val());
                            }
                        });
                        $fieldTypeSelector.trigger('change');
                    });
                }
                function addChoicesStaticRow(parent, fromClick = false) {
                    const parser = new DOMParser();
                    const index = parent.find('.optionsList > li').length;
                    const optionRow = $(parser.parseFromString(`<div class="optionsRow d-flex">
                    <div class="col-sm-6 optionDisplayCol"></div>
                    <div class="col-sm-5 optionValueCol" style="padding-left: 0; padding-right: 0">
                        <input placeholder="${T("Answer Value")}" type="text" class="editorTextfield underlyingValue form-control form-control-sm" />
                    </div>
                    <div class="col-sm-1 optionRemoveCol">
                        <a class="btn btn-danger btn-sm removeOption border-none" href="#removeOption"><i class="fa fa-times"></i></a>
                    </div>
                </div>`, 'text/html').body).find('.optionsRow');
                    const displayField = $(parser.parseFromString(`<div class="uiText" name="Option ${(index + 1)}" type="uiText">
                    <ul class="translations list-unstyled">
                        <li class="uiText-translation">
                            <div class="form-inline">
                                <input type="text" class="editorTextfield form-control form-control-sm" style="width:100%;" />
                            </div>
                        </li>
                    </ul>
                </div>`, 'text/html').body).find('.uiText');
                    displayField.find('ul input').attr('placeholder', T('Displayed Value'));
                    optionRow.find('.optionDisplayCol').append(displayField);
                    optionRow.find('.optionValueCol .editorTextfield').val('').on('input', function (event) {
                        var _a;
                        let index = -1;
                        index = Number((_a = $($($(this).closest('.optionsRow')).find('.uiText[name^="Option"]')).attr('name')) === null || _a === void 0 ? void 0 : _a.split(' ')[1]) - 1;
                        handleStaticOptions('put', 'value', String($(this).val()), index, parent);
                    });
                    optionRow.find('.optionDisplayCol .editorTextfield').val('').on('input', function (event) {
                        var _a;
                        let index = -1;
                        index = Number((_a = $($($(this).closest('.optionsRow')).find('.uiText[name^="Option"]')).attr('name')) === null || _a === void 0 ? void 0 : _a.split(' ')[1]) - 1;
                        handleStaticOptions('put', 'display', String($(this).val()), index, parent);
                    });
                    optionRow.find('.removeOption').on('click', function (event) {
                        event.preventDefault();
                        const row = $(this).closest('.optionsRow');
                        const option = row.find('.optionDisplayCol > .uiText');
                        const index = Number(String(option.attr('name')).split(' ')[1]) - 1;
                        handleStaticOptions('remove', undefined, undefined, index, parent);
                        const $optionsList = $(this).closest('.optionsList');
                        $(this).closest('li').remove();
                        $optionsList.children().each(function (i) {
                            $(this)
                                .toggleClass('even', (i % 2) === 0)
                                .find('.optionDisplayCol .uiText')
                                .attr('name', 'Option ' + (i + 1));
                        });
                    });
                    const newRow = $('<li></li>')
                        .toggleClass('even', (index % 2) === 0)
                        .append(optionRow);
                    parent.find('.optionsList').append(newRow);
                    if (fromClick)
                        handleStaticOptions('add', undefined, undefined, index, parent);
                }
                function getTypeSelectVal() {
                    let $currentTheme = getCurrentDesignerTheme();
                    return $currentTheme.find('.typeSelect .dropdown-toggle').data('typevalue');
                }
                function setTypeSelect(val, text) {
                    let $currentTheme = getCurrentDesignerTheme();
                    let $currentToggle = $currentTheme.find('.typeSelect .dropdown-toggle');
                    $currentToggle.data('typevalue', val);
                    if (text)
                        $currentToggle.text(text);
                    else {
                        const valText = $currentToggle.parent()
                            .find(".dropdown-menu")
                            .find("[data-typevalue='" + val + "']")
                            .first().text();
                        $currentToggle.text(valText);
                    }
                }
                function showSelectedTheme() {
                    if ($('.themeSelector').prop('selectedIndex') > 0)
                        $('.btnDeleteTheme').showElement();
                    else
                        $('.btnDeleteTheme').hideElement();
                    const selectedType = getTypeSelectVal();
                    $('.designerTheme').hide();
                    $('.fieldTheme').hide();
                    $('.control').removeClass('selected');
                    getCurrentDesignerTheme().find(`.id[value='${$('.themeSelector').val()}']`).closest('.designerTheme').show();
                    getCurrentDesignerTheme().find(`.fieldTheme.${selectedType}`).show();
                    $(`.control.${selectedType}`).addClass('selected');
                    getCurrentDesignerTheme().find('.colorPicker[data-default-color]').each(function () {
                        setDefaultColor($(this));
                    });
                    updateThemeDisplay();
                }
                function customSubmit(submitType) {
                    $('form').append(`<input type="hidden" name="submitType" value="${submitType}" />`);
                    $('form').submit();
                }
                function handleStaticOptions(action = appn.emptyString, type = appn.emptyString, value = appn.emptyString, index = -1, parent) {
                    const theme = parent.closest('.choices');
                    const themeIndex = Number(theme.attr('id'));
                    const staticOptions = theme.find('.staticList');
                    const staticListString = _StaticOptions[themeIndex];
                    let staticList = [];
                    if (staticListString.contains(','))
                        staticList = staticListString.split(',');
                    else if (staticListString.contains('|'))
                        staticList.push(staticListString);
                    if (action !== appn.emptyString) {
                        switch (action) {
                            case 'add': {
                                staticList.push('|');
                                break;
                            }
                            case 'remove': {
                                staticList.splice(index, 1);
                                break;
                            }
                            case 'put': {
                                const currentOption = staticList[index];
                                const currentDisplay = currentOption.split('|')[0];
                                const currentValue = currentOption.split('|')[1];
                                switch (type) {
                                    case 'display': {
                                        staticList.splice(index, 1, `${value}|${currentValue}`);
                                        break;
                                    }
                                    case 'value': {
                                        staticList.splice(index, 1, `${currentDisplay}|${value}`);
                                        break;
                                    }
                                }
                                break;
                            }
                            case 'populate': {
                                staticList.forEach(function (option, i) {
                                    addChoicesStaticRow(parent);
                                    const rows = parent.find('.optionsList > li');
                                    const row = $(rows[i]);
                                    row.find('.optionDisplayCol .editorTextfield').val(option.split('|')[0]);
                                    row.find('.optionValueCol .editorTextfield').val(option.split('|')[1]);
                                });
                                break;
                            }
                        }
                        _StaticOptions[themeIndex] = staticList.join(',');
                        staticOptions.val(staticList.join(','));
                    }
                }
                function updateThemeDisplay() {
                    getCurrentDesignerTheme().find('.fieldTheme').each(function () {
                        const theme = $(this);
                        let filter = $(this).find('.fieldType').map(function () {
                            return `.${$(this).val()}`;
                        }).get().join(',');
                        if (!filter)
                            filter = '.control';
                        $('.workspace').find('.control').filter(filter).each(function () {
                            const controlInfo = $(this).find('> .controlInfo');
                            updateTextStyle(controlInfo.find('.controlLabel'), theme.find('.labelStyle'), { Small: 1, Medium: 1.2, Large: 1.4 });
                            updateTextStyle(controlInfo.find('.controlHint'), theme.find('.hintStyle'), { Small: 0.8, Medium: 0.9, Large: 1.1 });
                            const layoutText = theme.find('.layoutStyle select').val();
                            if ($(this).hasClass('verticalLayout') || $(this).hasClass('horizontalLayout')) {
                                $(this).removeClass('verticalLayout').removeClass('horizontalLayout');
                                if (layoutText === 'Vertical')
                                    $(this).addClass('verticalLayout');
                                else
                                    $(this).addClass('horizontalLayout');
                            }
                            let backgroundElement = controlInfo.find('.controlHeadline');
                            backgroundElement.css('background-color', appn.emptyString);
                            controlInfo.css('background-color', appn.emptyString);
                            if ($(this).hasClass('horizontalLayout'))
                                backgroundElement = controlInfo;
                            backgroundElement.css('background-color', theme.find('.backgroundStyle .colorPicker').val());
                            if (theme.hasClass('field') && $(this).hasClass('inputMedia')) {
                                const themeIndex = theme.closest('.designerTheme').index();
                                const primaryCheckbox = theme.find('#ab-primary-bgtransparent-' + themeIndex);
                                const secondaryCheckbox = theme.find('#ab-secondary-bgtransparent-' + themeIndex);
                                const tertiaryCheckbox = theme.find('#ab-tertiary-bgtransparent-' + themeIndex);
                                const primaryTextPicker = theme.find('.tab-pane[data-name="btn0"] .backgroundStyle .colorPicker');
                                const secondaryTextPicker = theme.find('.tab-pane[data-name="btn1"] .backgroundStyle .colorPicker');
                                const tertiaryTextPicker = theme.find('.tab-pane[data-name="btn2"] .backgroundStyle .colorPicker');
                                if (primaryCheckbox.length)
                                    setActionButtonBackground($(this), 'media-btn0', primaryCheckbox);
                                if (secondaryCheckbox.length)
                                    setActionButtonBackground($(this), 'media-btn1', secondaryCheckbox);
                                if (tertiaryCheckbox.length)
                                    setActionButtonBackground($(this), 'media-btn2', tertiaryCheckbox);
                                if (primaryTextPicker.length)
                                    setMediaButtonTextColor($(this), 'media-btn0', primaryTextPicker);
                                if (secondaryTextPicker.length)
                                    setMediaButtonTextColor($(this), 'media-btn1', secondaryTextPicker);
                                if (tertiaryTextPicker.length)
                                    setMediaButtonTextColor($(this), 'media-btn2', tertiaryTextPicker);
                            }
                            if (filter.contains('inputChoices')) {
                                const displayStyleText = theme.find('.displayStyle select').val();
                                if ($(this).hasClass('displayDropdown') || $(this).hasClass('displayListOfChoices') || $(this).hasClass('displayAutoComplete')) {
                                    $(this).removeClass('displayDropdown').removeClass('displayListOfChoices').removeClass('displayAutoComplete');
                                    const choices = $(this).find('.wireField .wireListOfChoices');
                                    choices.each(function (index, choice) {
                                        $(choice).hideElement();
                                    });
                                    if (displayStyleText === 'Drop Down List')
                                        $(this).addClass('displayDropdown');
                                    else if (displayStyleText === 'List of Choices') {
                                        $(this).addClass('displayListOfChoices');
                                        if ($(this).hasClass('verticalLayout'))
                                            setOptionColors($('.control.choices'), $('.fieldTheme.choices'), true);
                                        choices.each(function (index, choice) {
                                            if (index < 3)
                                                $(choice).showElement();
                                        });
                                    }
                                    else
                                        $(this).addClass('displayAutoComplete');
                                }
                                const optionsSections = theme.find('.optionColors, .option-bg');
                                optionsSections.each(function (index, option) {
                                    if (!$(option).hasClass('d-none'))
                                        $(option).addClass('d-none');
                                });
                                if ($(this).hasClass('displayListOfChoices') && $(this).hasClass('horizontalLayout')) {
                                    optionsSections.removeClass('d-none');
                                    setOptionColors($('.control.choices'), theme.find('.multi-color-content.optionColors'));
                                }
                            }
                            if (filter.contains('inputAction'))
                                theme.find('.button').each((index, button) => {
                                    const dataName = $(button).data('name');
                                    const styleElement = $(button).find('.fontStyle');
                                    const control = $(`.control.action`);
                                    const checkbox = $(button).find('.colorSelector input[type="checkbox"]');
                                    setActionButtonStyle(control, dataName, styleElement);
                                    setActionButtonBackground(control, dataName, checkbox);
                                });
                        });
                    });
                }
                function updateTextStyle(element, textStyle, fontSizes, noColorUpdate) {
                    const fontSizeText = textStyle.find('select').val();
                    const fontStyleText = textStyle.find('.decor').val();
                    const fontColorText = textStyle.find('.colorPicker').val();
                    element.css('font-style', appn.emptyString).css('font-weight', appn.emptyString);
                    if (noColorUpdate)
                        element.css('font-size', `${fontSizes[fontSizeText]}em`).css('font-style', fontStyleText).css('font-weight', fontStyleText);
                    else
                        element.css('font-size', `${fontSizes[fontSizeText]}em`).css('color', fontColorText).css('font-style', fontStyleText).css('font-weight', fontStyleText);
                }
                function getCurrentDesignerTheme() {
                    return $(`.designerTheme .id[value='${$('.themeSelector').val()}']`).closest('.designerTheme');
                }
                function setBackgroundColor(checkbox) {
                    checkbox.on('change', function () {
                        const $thisCheckbox = $(this);
                        const $parent = $thisCheckbox.closest('.backgroundStyle, .colorSelector');
                        const $colorPicker = $parent.find('.colorPicker');
                        if ($thisCheckbox.is(':checked')) {
                            $colorPicker.val(appn.emptyString).minicolors('value', '');
                        }
                        else if (!$colorPicker.val()) {
                            const defaultColor = $colorPicker.data('default-color') || '#EEEEEE';
                            $colorPicker.val(defaultColor).minicolors('value', defaultColor);
                        }
                    });
                }
                function setOptionColors(control, multiColorSelector, clear) {
                    const colorBoxes = [];
                    colorBoxes.push(String(multiColorSelector.find('.colorPicker1').val()));
                    colorBoxes.push(String(multiColorSelector.find('.colorPicker2').val()));
                    colorBoxes.push(String(multiColorSelector.find('.colorPicker3').val()));
                    colorBoxes.push(String(multiColorSelector.find('.colorPicker4').val()));
                    colorBoxes.push(String(multiColorSelector.find('.colorPicker5').val()));
                    const buttons = control.find('.wireListOfChoices');
                    $(buttons).each(function (index, button) {
                        const buttonElement = $(button);
                        buttonElement.css('background-color', appn.emptyString);
                        buttonElement.hideElement();
                        if (colorBoxes[index] !== appn.emptyString) {
                            buttonElement.css('background-color', colorBoxes[index]);
                            buttonElement.showElement();
                            if (clear) {
                                buttonElement.css('background-color', '');
                                buttonElement.hideElement();
                            }
                        }
                    });
                }
                function setActionButtonStyle(control, dataName, style) {
                    const button = control.find(`.wireButton[data-name="${dataName}"]`);
                    updateTextStyle(button, style, { Small: 1, Medium: 1.2, Large: 1.4 });
                }
                function setActionButtonBackground(control, dataName, checkbox) {
                    const colorPicker = checkbox.closest('.colorSelector').find('.colorPicker');
                    if (checkbox.is(':checked')) {
                        colorPicker.val(appn.emptyString).minicolors('value', '');
                    }
                    else if (!colorPicker.val()) {
                        const defaultColor = colorPicker.data('default-color') || '#DDDDDD';
                        colorPicker.val(defaultColor).minicolors('value', defaultColor);
                    }
                    const button = control.find(`.wireButton[data-name="${dataName}"]`);
                    button.css('background', colorPicker.val());
                }
                function setMediaButtonTextColor(control, dataName, colorInput) {
                    const button = control.find(`.wireButton[data-name="${dataName}"]`);
                    button.css('color', colorInput.val());
                }
                function setDefaultColor(colorInput) {
                    const currentValue = colorInput.val();
                    const defaultColor = colorInput.data('default-color');
                    if (!currentValue || currentValue.trim() === '') {
                        colorInput.val(defaultColor);
                        colorInput.minicolors('value', defaultColor);
                    }
                }
                $(function () {
                    $(document).on('change', 'input.colorPicker[data-default-color]', function () {
                        const $this = $(this);
                        setTimeout(() => {
                            const currentValue = $this.val();
                            if (!currentValue || currentValue.trim() === '') {
                                const defaultColor = $this.data('default-color');
                                $this.val(defaultColor);
                                $this.minicolors('value', defaultColor);
                            }
                        }, 50);
                    });
                });
                function showFormulaButtons(control) {
                    control.closest('div.propContent').find('div.formula').showElement();
                    control.closest('div.propContent').find('.color-picker').hideElement();
                }
                function hideFormulaButtons(control) {
                    control.closest('div.propContent').find('div.color-picker').showElement();
                    control.closest('div.propContent').find('.formula').hideElement();
                }
                function updateInfoAlertColors(control) {
                    const value = control.val();
                    const id = control.attr('id');
                    if (id.contains('subtitle'))
                        $('.controlLabelInfoAlertSubtitle').css('color', value.startsWith('#') ? value : '#f24444');
                    else if (id.contains('title'))
                        $('.controlLabelInfoAlertTitle').css('color', value.startsWith('#') ? value : '#3F3F3F');
                    else if (id.contains('bgColor'))
                        $('#infoAlertPreview').css('backgroundColor', value.startsWith('#') ? value : '#FFFFFF');
                }
                function updateInfoAlertText() {
                    const titleText = $('.titleInput:not(.d-none) input').val();
                    const subtitleText = $('.subtitleInput:not(.d-none) input').val();
                    $('.controlLabelInfoAlertTitle').text(appn.utils.hasValue(titleText) ? titleText : T('You have 2 Tasks Outstanding'));
                    $('.controlLabelInfoAlertSubtitle').text(appn.utils.hasValue(subtitleText) ? subtitleText : T('1 Overdue!'));
                }
                function formatIcon(icon) {
                    if (!icon.id) {
                        return icon.text;
                    }
                    let $icon = $('<span style="display: flex; align-items: center;">' +
                        '<img src="' + $(icon.element).data('imagesrc') + '" style="height: 1.2em; margin-right: 4px;" />' +
                        '<span>' + icon.text + '</span>' +
                        '</span>');
                    return $icon;
                }
            })(index = appBuilder.index || (appBuilder.index = {}));
        })(appBuilder = views.appBuilder || (views.appBuilder = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
